// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_YF6TR","box":"index_box_KMhos","footerbox":"index_footerbox_0znGy"};